// 繁体中文语言包
import ucExtra from './uc-extra-zh-tw.js'

export default {
  ...ucExtra,
  common: {
    confirm: '確認',
    cancel: '取消',
    submit: '提交',
    reset: '重置',
    search: '查詢',
    add: '新增',
    edit: '編輯',
    delete: '刪除',
    remove: '移除',
    save: '保存',
    close: '關閉',
    back: '返回',
    next: '下一步',
    prev: '上一步',
    loading: '加載中...',
    noData: '暫無數據',
    operation: '操作',
    status: '狀態',
    createTime: '創建時間',
    updateTime: '更新時間',
    actions: '操作',
    success: '成功',
    fail: '失敗',
    warning: '警告',
    error: '錯誤',
    tips: '提示',
    pleaseSelect: '請選擇',
    pleaseInput: '請輸入',
    normal: '正常',
    disabled: '停用',
    pleaseLoginFirst: '請先登錄後再訪問'
  },

  login: {
    title: '登錄',
    welcome: '歡迎使用',
    platformName: '深圳市版權公共服務平台',
    tab: {
      personal: '個人賬戶',
      enterprise: '企業賬戶'
    },
    personalLogin: '個人登錄',
    enterpriseLogin: '企業登錄',
    username: '用戶名',
    password: '密碼',
    phone: '手機號',
    verifyCode: '驗證碼',
    getVerifyCode: '獲取驗證碼',
    rememberMe: '記住我',
    forgotPassword: '忘記密碼',
    loginButton: '登錄',
    register: '註冊',
    logout: '退出登錄',
    submit: '登錄',
    placeholder: {
      phone: '請輸入手機號',
      smsCode: '請輸入驗證碼',
      enterpriseAccount: '請輸入企業賬號',
      password: '請輸入密碼'
    },
    sms: {
      getCode: '獲取驗證碼',
      retryAfter: '{n}秒後重試',
      cantReceive: '收不到驗證碼?',
      cantReceiveQ: '收不到驗證碼？'
    },
    agree: {
      prefix: '勾選即為同意',
      privacy: '《隱私協議》',
      and: '和',
      register: '《註冊協議》'
    },
    personal: {
      wechatScan: '微信掃碼登錄',
      phoneLogin: '手機號登錄',
      qrLoading: '二維碼加載中...',
      reload: '重新加載',
      altQrcode: '微信登錄二維碼',
      scanSuccess: '掃碼登錄成功',
      qrExpired: '二維碼已失效',
      clickRefresh: '點擊刷新',
      agreeFirstHint: '請先勾選同意隱私協議和註冊協議',
      loginQrLabel: '登錄二維碼'
    },
    enterprise: {
      adminPhone: '管理員手機號登錄',
      accountLogin: '企業賬號登錄',
      rememberMe: '記住我',
      forgotPassword: '忘記密碼？'
    },
    bindPhone: {
      title: '綁定手機號',
      submit: '綁定'
    },
    validation: {
      phoneRequired: '請輸入手機號',
      phoneInvalid: '請輸入正確的手機號',
      smsRequired: '請輸入驗證碼',
      smsLen: '驗證碼為6位數字',
      accountRequired: '請輸入企業賬號',
      passwordRequired: '請輸入密碼',
      passwordMin: '密碼長度不能少於6位'
    },
    toast: {
      agreeFirstCheckbox: '請先勾選同意隱私協議和註冊協議',
      qrFailed: '獲取二維碼失敗，請重試',
      agreeFirst: '請先同意隱私協議和註冊協議',
      bindSuccess: '手機號綁定成功',
      smsNotReceived: '如未收到驗證碼，請檢查手機號是否正確或稍後重試',
      formRefMissing: '表單引用不存在，請刷新頁面重試',
      smsSent: '驗證碼已發送',
      bindPhoneFirst: '請先完成手機號綁定',
      loginSuccess: '登錄成功'
    },
    alertTip: '提示',
    forgot: {
      title: '密碼找回',
      labelAccount: '主體賬號',
      placeholderAccount: '請輸入主體賬號',
      labelContactPhone: '主體聯繫人電話',
      placeholderContactPhone: '請輸入主體聯繫人電話',
      labelSmsCode: '驗證碼',
      placeholderSmsCode: '請輸入驗證碼',
      tip: '提交後，系統自動以郵件方式發送當前主體賬號新密碼，請注意查收，妥善保管。',
      submit: '確認找回',
      smsSend: '發送驗證碼',
      smsRetryAfter: '{n}秒後重試',
      validation: {
        phoneRequired: '請輸入主體聯繫人電話',
        phoneInvalid: '請輸入正確的主體聯繫人電話',
        accountRequired: '請輸入主體賬號',
        smsRequired: '請輸入驗證碼',
        smsLen: '驗證碼為6位數字'
      },
      toast: {
        smsSent: '驗證碼已發送',
        success: '密碼找回成功，新密碼已發送至主體聯繫人郵箱'
      }
    },
    privacyPageTitle: '深圳市版權公共服務平台隱私政策',
    registerPageTitle: '深圳市版權公共服務平台用戶註冊協議'
  },

  userCenter: {
    title: '用戶中心',
    account: '賬號管理',
    message: '消息通知',
    approval: '我的審批',
    identity: '身份認證',
    admin: '企業管理員',
    lastLoginTime: '最後登錄時間：',
    associationMember: '協會會員',
    avatarAlt: '用戶頭像',
    changeAvatar: '更換頭像',
    nickname: '暱稱：',
    nicknamePlaceholder: '請輸入暱稱',
    save: '保存',
    cancel: '取消',
    realName: '真實姓名：',
    enterpriseName: '企業名稱：',
    channelName: '渠道名稱：',
    organizationName: '機構名稱：',
    registerTime: '註冊時間：',
    channelRelation: '所屬{type}：{name}',
    channelType: '渠道',
    organizationType: '機構',
    tabs: {
      account: '賬號管理',
      rights: '我的權益',
      myRecord: '我的備案',
      order: '我的訂單',
      invoice: '我的發票',
      myConsultation: '我的諮詢',
      activity: '我的活動',
      collection: '我的收藏',
      message: '消息通知'
    },
    accountMenu: {
      personalAuth: '個人實名認證',
      enterpriseAuth: '企業身份認證',
      assessment: '企業號考核圖',
      management: '企業管理員',
      resetPassword: '重置密碼',
      myApproval: '我的授權'
    },
    rightsMenu: {
      freeRights: '新用戶免費權益',
      platformVip: '平台大會員套餐'
    },
    verifyStatus: {
      unverified: '未認證',
      verifying: '認證中',
      verified: '已認證',
      rejected: '未通過'
    },
    btn: {
      createEnterprise: '認證新企業賬號 +',
      exitAdmin: '解除管理員身份',
      cancelChannelProxy: '取消渠道代理',
      exitChannel: '退出渠道',
      exitInstitution: '退出機構',
      joinChannel: '加入渠道',
      copyrightPublicAction: '版權公益護航'
    },
    msg: {
      underDevelopment: '正在開發中',
      completePersonalAuthFirst: '請先完成個人身份認證',
      avatarImageOnly: '只能上傳圖片文件!',
      avatarSizeLimit: '圖片大小不能超過 2MB!',
      uploading: '上傳中...',
      avatarUploadSuccess: '頭像上傳成功',
      avatarUploadFail: '頭像上傳失敗',
      avatarUploadFailRetry: '頭像上傳失敗，請重試',
      nicknameRequired: '暱稱不能為空',
      nicknameSaveSuccess: '暱稱保存成功',
      saveFail: '保存失敗',
      saveFailRetry: '保存失敗，請重試',
      exitChannelSuccess: '退出渠道成功',
      cancelChannelProxySuccess: '取消渠道代理成功',
      exitInstitutionSuccess: '退出機構成功',
      getEnterpriseIdFail: '獲取企業ID失敗，請重試'
    },
    confirm: {
      title: '提示',
      ok: '確定',
      exitAdmin: '確定要手動解除您在 {enterpriseName} 中的企業管理員身份嗎？',
      exitChannel: '確定要退出渠道嗎？',
      cancelChannelProxy: '確定要取消渠道代理嗎？',
      exitInstitution: '確定要退出機構嗎？'
    }
  },

  freeRights: {
    bannerAlt: '完成身份認證，即可永久免費使用基礎功能',
    goAuth: '立即認證',
    authTips: '認證僅需1-2分鐘，馬上開啟您的版權管理之旅',
    benefits: {
      ipDataInquiry: {
        title: '知產數據查詢',
        bullet1: '免費查詢本企業知識產權數據資產（限企業賬戶）'
      },
      workRegistration: {
        title: '作品備案管理',
        bullet1: '免費雲端存儲備案作品',
        bullet2: '免費建立個人或企業備案作品庫'
      },
      educationTraining: {
        title: '版權教育培訓',
        bullet1: '免費學習基礎版權能力課程',
        bullet2: '免費下載版權合同模板及學習資料',
        bullet3: '免費獲取版權資訊及國際動態'
      }
    }
  },

  copyrightPublicAction: {
    dialogTitle: '版權公益行動',
    intro: '本平台為以下四類身份開放版權公益護航免費權益申請',
    authHintPrefix: '請完成身份實名認證後進行申請提交，前往',
    authLink: '身份實名認證 »',
    identity: {
      student: '學生',
      studentDesc: '在校學生，個人學習或研究使用',
      school: '學校',
      schoolDesc: '各級院校及教育機構',
      commonweal: '公益組織',
      commonwealDesc: '非營利性質的社會公益組織',
      association: '版權產業社會團體/協會',
      associationDesc: '版權相關行業協會及團體組織',
      fallback: '該身份'
    },
    time: {
      approvedAt: '申請通過時間:',
      expiresAt: '權益到期時間:',
      appliedAt: '申請時間:',
      rejectedAt: '駁回時間:'
    },
    dateTimePattern: '{y}年{m}月{d}日 {hh}:{mm}:{ss}',
    emptyDash: '—',
    status: {
      rejected: '未通過',
      unknown: '未知',
      approved: '已通過',
      auditStatus: '審核狀態：',
      applyTime: '申請時間：',
      expireTime: '到期時間：',
      rejectTime: '駁回時間：',
      remark: '備註：'
    },
    btn: {
      apply: '去申請',
      reapply: '重新申請',
      viewDetail: '查看申請詳情',
      prev: '上一步',
      submit: '提交申請',
      close: '關閉'
    },
    msg: {
      cannotSwitchType: '您已有版權公益申請記錄，無法切換申請類型',
      notOpenYet: '暫未開放，敬請期待！',
      identityNotSupported: '當前身份不支持申請{identity}權益',
      completeAuthFirst: '請先完成身份實名認證！',
      resubmitSuccess: '重新提交成功',
      submitSuccess: '申請提交成功'
    },
    loading: {
      submitting: '提交中...'
    },
    enterprise: {
      title: {
        school: '學校認證',
        commonweal: '公益組織認證',
        association: '版權產業社會團體/協會認證',
        fallback: '企業認證'
      },
      nameLabel: {
        school: '學校名稱',
        commonweal: '組織名稱',
        association: '協會名稱',
        fallback: '企業名稱'
      },
      creditCode: '統一社會信用代碼',
      usageScenario: '公益使用場景',
      usageScenarioPlaceholder: '請填寫貴單位使用本平台公益護航權益的使用場景',
      ruleUsageScenario: '請填寫公益使用場景'
    },
    student: {
      dialogTitle: '學生認證',
      bannerAlt: '學生申請',
      warning: '說明：僅與本平台對接開通 {highlight} 公益行動的學校在籍學生方可申請開通本權益',
      warningHighlight: '青少年版權「校園護航」',
      name: '姓名',
      idCard: '身份證號碼',
      uploadReport: '上傳學信網驗證報告',
      viewReport: '查看報告',
      schoolName: '學校名稱',
      major: '專業',
      enrollmentTime: '入學時間',
      graduationTime: '預計畢業時間',
      placeholder: '請輸入',
      rule: {
        report: '請上傳學信網驗證報告',
        schoolName: '請輸入學校名稱',
        major: '請輸入專業',
        enrollmentTime: '請選擇入學時間',
        graduationTime: '請選擇預計畢業時間'
      }
    },
    upload: {
      hintLine1: '點擊上傳《教育部學籍在線驗證報告》',
      hintLine2: '僅支持上傳PDF格式，單個文件大小不超過5Mb',
      uploadedPrefix: '已上傳：',
      goChsi: '前往學信網下載 »',
      pdfOnly: '僅支持上傳PDF格式文件',
      sizeLimit: '文件大小不能超過 {maxSize}MB',
      loading: '識別中...',
      success: '上傳並識別成功',
      noFileUrl: '識別完成但未獲取到文件存儲地址，請重試'
    }
  },

  message: {
    title: '消息通知',
    unread: '未讀',
    read: '已讀',
    starred: '標星',
    all: '全部',
    system: '系統消息',
    business: '業務消息',
    activity: '活動消息',
    noMessage: '暫無消息',
    noMessageDetail: '暫無消息詳情',
    markAsRead: '標記為已讀',
    markAsUnread: '標記為未讀',
    star: '標星',
    unstar: '取消標星',
    delete: '刪除消息',
    time: '時間',
    sender: '發送者',
    altIcon: '消息',
    unreadTitle: '未讀消息',
    allMessages: '全部消息'
  },

  approval: {
    title: '我的審批',
    pending: '待審批',
    approved: '已通過',
    rejected: '已駁回',
    applicant: '申請人',
    approver: '審批人',
    businessType: '業務類型',
    approvalStatus: '審批狀態',
    remark: '備註',
    approve: '通過',
    reject: '駁回',
    approvalTime: '審批時間',
    sendApproval: '發送審批',
    approvalResult: '審批結果'
  },

  ipMgmt: {
    title: '知識產權管理',
    subtitle: '提供企業級知識產權資產全生命周期安全管理，助力企業高效盤活知識產權價值。',
    goManage: '前往知識產權管理',
    regionDomestic: '國內數據統計',
    regionInternational: '國際數據統計',
    startManage: '開啟管理',
    expiryRemind: '知產到期提醒',
    dataUpdate: '知產數據更新',
    reportDownload: '知產報告下載',
    reportExample: '報告示例',
    tabOverview: '{name}總覽',
    tabList: '{name}清單',
    tabCert: '{name}證書管理',
    overviewTip: '導入知識產權證書，解鎖多維度日期分析圖表。',
    asset: {
      all: '全部知產',
      ip: '知識產權',
      digitalFiling: '數字備案',
      workCopyright: '作品著作權',
      softwareCopyright: '軟件著作權',
      trademark: '商標',
      patent: '專利'
    },
    switchedTo: '已切換至：{name}',
    developing: '此功能正在開發中...',
    updateConfirmTitle: '更新確認',
    updateConfirmHtml:
      '確定同步更新當前主體下的<strong>作品著作權、軟件著作權、商標、專利</strong>清單數據嗎？' +
      '<br/><span style="color: #f56c6c;">(該操作會將查詢結果同步到知產管理中。若知產管理中的數據未在查詢結果中，則會被刪除！)</span>',
    updateSuccess: '知產數據已更新',
    updateFail: '更新失敗',
    syncing: '同步中，請稍候...',
    startDialog: {
      title: '導入數據，開啟知識產權資產數字化管理',
      guide: '使用步驟示範指南',
      queryTitle: '知識產權數據查詢一鍵導入',
      queryAlt: '知識產權數據查詢一鍵導入',
      goQuery: '去查詢',
      queryFooter: '企業用戶推薦使用方式',
      uploadTitle: '上傳數據表格導入',
      uploadAlt: '上傳數據表格導入',
      goImport: '去導入',
      uploadFooter: '企業用戶/個人用戶均可使用方式',
      close: '關閉'
    },
    overview: {
      stats: '知識產權統計',
      analysis: '知識產權分析',
      share: '知識產權佔比',
      structure: '知識產權結構態勢',
      exportPng: '導出為 PNG 圖片',
      to: '至',
      allTime: '所有時間',
      byYear: '按年統計',
      byQuarter: '按季統計',
      byMonth: '按月統計',
      selectYear: '選擇年份',
      piece: '件',
      total: '總計',
      quantity: '知識產權數量',
      lastMonth: '近一個月',
      lastHalfYear: '近半年',
      lastYear: '近一年',
      sum: '合計',
      currentCount: '當前數量',
      yearLabel: '{n}年',
      monthLabel: '{n}月',
      q1: '第一季度',
      q2: '第二季度',
      q3: '第三季度',
      q4: '第四季度',
      exportConfirm: '確定將「{title}」導出為 PNG 圖片到本地嗎？',
      exportConfirmTitle: '確認導出',
      export: '導出',
      chartNotReady: '圖表尚未就緒，請稍後再試',
      downloadSuccess: '圖片已下載',
      exportFail: '導出失敗',
      digitalStats: '數字備案統計',
      digitalAnalysis: '數字備案分析',
      digitalShare: '數字備案佔比',
      typeStats: '{name}統計',
      typeAnalysis: '{name}分析',
      typeShare: '{name}佔比',
      originalWork: '原創作品',
      productDesign: '產品設計存證',
      originalFiling: '原創數字備案',
      productFiling: '產品發佈存證',
      filingCount: '備案數量',
      originalShare: '原創作品佔比',
      productShare: '產品設計存證佔比',
      analysisOf: '{date}分析'
    },
    list: {
      addData: '新增數據',
      importData: '導入數據',
      exportData: '導出數據',
      linkAllCerts: '關聯全部證書',
      viewCert: '查看證書',
      bindCert: '綁定證書',
      unbindCert: '解綁證書',
      goUploadCert: '前往證書管理上傳證書',
      certCover: '證書封面（點擊可放大預覽）',
      noCertCover: '暫無證書封面',
      certNo: '證書編號',
      certType: '證書類型',
      bound: '已綁定',
      unbound: '未綁定',
      bindCertTitle: '綁定證書',
      unbindCertTitle: '解綁證書',
      confirmBind: '確定綁定',
      confirmUnbind: '確定解綁',
      loadingCert: '正在查詢證書…',
      loadingBoundCert: '正在加載已綁定證書信息…',
      exportConfirm: '確定導出當前篩選條件下的 {total} 條數據嗎？',
      exportConfirmTitle: '導出確認',
      exporting: '導出中，請稍候…',
      noExportData: '暫無可導出的數據',
      deleteConfirmTitle: '刪除確認',
      deleteConfirm: '確定刪除「{title}」記錄嗎？',
      deleting: '刪除中...',
      openingCert: '正在打開證書…',
      batchLinkTitle: '關聯知產證書與數據',
      batchLinkDesc: '關聯證書到知產數據管理中...',
      batchLinkConfirmTitle: '關聯確認',
      batchLinkConfirmOk: '確定關聯',
      batchLinkProgress: '證書關聯進度',
      batchLinkNoData: '當前沒有需要關聯的數據！',
      batchLinkSuccess: '當前關聯成功：{n}',
      batchLinkFail: '當前關聯失敗：{n}',
      batchLinkFailed: '關聯失敗',
      batchLinkConfirmMsg:
        '將為當前賬號下所有「未綁定證書」的{name}清單記錄，按登記號自動匹配證書庫中未關聯的「{name}」證書並綁定；登記號為空、無匹配證書或證書已關聯的記錄將跳過。是否繼續？',
      typeFallback: '該類型知產',
      thisRecord: '該條',
      fields: {
        regNo: '登記號',
        workName: '作品名稱',
        workType: '作品類別',
        author: '作者',
        completeDate: '創作完成日期',
        regDate: '登記日期',
        remark: '備註',
        bindCertFlag: '是否綁定證書',
        softwareName: '軟件名稱',
        version: '版本號',
        rightHolder: '著作權人/權利人',
        tmRegNo: '註冊號',
        tmName: '商標名稱',
        tmPic: '商標圖樣',
        applicant: '申請人',
        applyDate: '申請日期',
        tmRegDate: '註冊日期',
        expireDate: '到期日期',
        tmClass: '商標分類',
        goodsServices: '商品和服務分類',
        patentNo: '專利號',
        patentName: '專利名稱',
        patentType: '專利類型',
        inventor: '發明人',
        grantDate: '授權公告日',
        status: '狀態',
        filingNo: '備案編號',
        filingType: '備案類型',
        digitalFilingNo: '數字備案編號',
        workCategory: '作品分類',
        serialNo: '序號'
      },
      ph: {
        regNo: '請輸入登記號',
        workName: '請輸入作品名稱',
        workType: '請輸入作品類別',
        selectWorkType: '請選擇作品類別',
        author: '請輸入作者',
        date: '請選擇日期',
        remark: '請輸入備註',
        softwareName: '請輸入軟件名稱',
        version: '請輸入版本號',
        rightHolder: '請輸入著作權人/權利人',
        tmRegNo: '請輸入註冊號',
        tmName: '請輸入商標名稱',
        applicant: '請輸入申請人',
        selectTmClass: '請選擇商標分類',
        goodsServices: '請輸入商品和服務分類',
        imageUrl: '圖片 URL（必填）',
        patentNo: '請輸入專利號',
        patentName: '請輸入專利名稱',
        selectPatentType: '請選擇專利類型',
        inventor: '請輸入發明人',
        statusOptional: '狀態（可選）',
        all: '全部',
        selectRegDate: '請選擇登記日期'
      },
      importTitle: {
        work: '作品著作權導入',
        software: '軟件著作權導入',
        trademark: '商標導入',
        patent: '專利導入'
      },
      importTemplate: {
        work: '作品著作權導入模板.xlsx',
        software: '軟件著作權導入模板.xlsx',
        trademark: '商標導入模板.xlsx',
        patent: '專利導入模板.xlsx'
      },
      formTitle: {
        addWork: '新增作品著作權',
        editWork: '編輯作品著作權',
        addSoftware: '新增軟件著作權',
        editSoftware: '編輯軟件著作權',
        addTrademark: '新增商標',
        editTrademark: '編輯商標',
        addPatent: '新增專利',
        editPatent: '編輯專利'
      },
      toast: {
        addSuccess: '新增成功',
        addFail: '新增失敗',
        saveSuccess: '保存成功',
        saveFail: '保存失敗',
        deleteSuccess: '刪除成功',
        unboundCert: '未綁定證書',
        getCertFail: '獲取證書信息失敗',
        noCertFileUrl: '該證書暫無文件地址',
        missingIdSave: '無法保存：缺少記錄 ID',
        missingIdEdit: '無法編輯：缺少記錄 ID',
        missingIdBind: '無法綁定：缺少記錄 ID',
        missingIdUnbind: '無法解綁：缺少記錄 ID',
        missingIdDelete: '無法刪除：缺少記錄 ID',
        certNotFound: '未找到與當前登記號、類型匹配的證書，請確認證書庫中已存在對應記錄',
        certNotFoundBind: '未找到與當前登記號、類型匹配的證書，請確認證書庫中已存在對應記錄後再綁定',
        foundUnlinkedCert: '已查詢到未關聯的證書數據：{name}',
        noName: '（無名稱）',
        loadedBoundCert: '已加載當前綁定證書：{name}',
        loadCertFail: '加載證書信息失敗',
        certTypeMismatch: '已綁定證書類型與當前清單不一致，請從對應類型清單中解綁',
        emptyRegNo: '當前行登記號為空，無法綁定證書',
        missingCertType: '證書類型缺失，無法綁定',
        waitCertLoad: '請等待證書信息加載完成',
        bindSuccess: '綁定成功',
        bindFail: '綁定失敗',
        unbindSuccess: '解綁成功',
        unbindFail: '解綁失敗',
        notBoundWork: '當前作品未綁定證書',
        missingWorkRecord: '無法綁定：缺少作品記錄',
        missingUnbindRecord: '無法解綁：缺少作品記錄',
        uploadImage: '上傳圖片',
        uploading: '上傳中…',
        orFillImageUrl: '或填寫下方圖片地址（上傳成功會寫入地址欄）',
        classN: '第{n}類',
        view: '查看',
        emptyFilingNo: '備案編號為空，無法查看',
        certNotFoundShort: '未找到對應證書',
        needTmPic: '請上傳或填寫商標圖樣'
      }
    },
    cert: {
      searchPlaceholder: '請輸入證書名或證書號全稱查詢',
      filingSearchPlaceholder: '請輸入作品名稱或數字備案編號查詢',
      noCertFile: '暫無證書文件',
      pdfThumbTitle: '證書 PDF 預覽縮略圖',
      upload: '上傳證書',
      uploadTitle: '上傳證書（{type}）',
      uploadDomestic: '上傳中國大陸證書',
      uploadInternational: '上傳國際證書',
      dropHint: '點擊或拖入上傳證書',
      fileTip: '支持 JPG、PNG 與 PDF，單文件最大 5MB',
      uploadCount: '當前上傳數量：',
      uploadProgress: '上傳證書進度',
      confirmUpload: '確認上傳',
      preview: '預覽證書',
      download: '下載證書',
      editInfo: '編輯證書信息',
      editAria: '修改證書信息',
      selectAria: '選擇證書',
      unselectAria: '取消選擇',
      previewAlt: '證書預覽',
      coverAlt: '證書封面',
      noCover: '暫無封面',
      certName: '證書名',
      certNo: '證書號',
      certType: '證書類型',
      placeholderCertName: '請輸入證書名',
      placeholderCertNo: '請輸入證書號',
      placeholderCertType: '請選擇證書類型',
      regDate: '註冊日期',
      expireDate: '到期日期',
      placeholderRegDate: '請選擇註冊日期',
      placeholderExpireDate: '請選擇到期日期',
      filterAll: '全部',
      filterLinked: '已關聯證書',
      filterUnlinked: '未關聯證書',
      onlyUnlinkedEdit: '僅「未關聯」狀態的證書可以修改信息',
      onlyUnlinkedDelete: '僅「未關聯」狀態的證書可以刪除，請取消選擇已關聯的證書後重試。',
      selectToDelete: '請先選擇要刪除的證書',
      deleteConfirm: '確定刪除選中的 {n} 條未關聯證書嗎？刪除後不可恢復。',
      deleteConfirmTitle: '刪除確認',
      confirmDelete: '確定刪除',
      deleting: '刪除中...',
      deleteSuccess: '刪除成功',
      editSuccess: '修改成功',
      noPreviewCover: '暫無可預覽的證書封面圖片',
      noPreviewFile: '暫無可預覽的證書文件',
      noDownloadFile: '暫無可下載的證書文件',
      downloadConfirm: '確定要下載該證書文件嗎？',
      downloadConfirmTitle: '下載確認',
      confirmDownload: '確定下載',
      unsupportedFormat: '不支持的文件格式：{name}',
      fileTooLarge: '文件超過 5MB：{name}',
      addFilesFirst: '請先添加待上傳的證書文件',
      uploadDone: '上傳完成',
      ruleCertName: '請輸入證書名',
      ruleCertNo: '請輸入證書號',
      ruleCertType: '請選擇證書類型',
      statusLinked: '已關聯',
      statusUnlinked: '未關聯'
    }
  },

  workbench: {
    title: '工作台',
    subtitle: '管理您的用戶與業務',
    role: {
      channel: '渠道',
      organization: '機構',
      salesman: '業務員'
    },
    updateChannelCode: '更新渠道碼',
    channelCodeDialog: {
      code: '渠道碼',
      expireTime: '失效時間',
      expireTip: '請設置渠道碼的失效時間',
      placeholderExpire: '請選擇到期時間',
      ruleCode: '請輸入渠道碼',
      ruleCodeLen: '渠道碼長度在 1 到 50 個字符',
      ruleExpire: '請選擇失效時間',
      dayN: '{n}天',
      loadFail: '獲取渠道碼信息失敗，您可以手動輸入渠道碼',
      updateSuccess: '渠道碼修改成功',
      updateFail: '渠道碼修改失敗',
      updateFailRetry: '修改渠道碼失敗，請稍後重試'
    },
    unbindSalesman: '解綁業務員身份',
    unbindConfirmTitle: '解綁確認',
    unbindConfirmMessage: '確定要解綁業務員身份嗎？解綁後將無法使用業務員相關功能。',
    unbindConfirmOk: '確定解綁',
    unbindSuccess: '解綁成功！',
    disabledTitle: '當前賬號工作台操作不可用',
    disabledDesc: '您的業務員賬號無法使用工作台相關功能。如有疑問請聯繫機構管理員。',
    tabs: {
      subChannel: '子渠道管理',
      user: '用戶管理',
      salesman: '業務員管理',
      dataStats: '數據統計'
    },
    all: '全部',
    dataStats: {
      byYear: '按年統計',
      byQuarter: '按季統計',
      byMonth: '按月統計',
      selectYear: '選擇年份',
      yearFormat: 'YYYY年',
      subChannelStats: '服務子渠道統計',
      subChannelStatsTotal: '服務子渠道總數統計',
      subChannelAnalysis: '服務子渠道分析',
      subChannelBusinessStats: '服務子渠道業務統計',
      subChannelBusinessStatsTotal: '服務子渠道業務總數統計',
      subChannelBusinessAnalysis: '服務子渠道業務分析',
      unverified: '未認證',
      personalAuth: '個人認證',
      enterpriseAuth: '企業認證',
      originalFiling: '原創作品備案',
      productDeposit: '產品發佈存證',
      ipQuery: '知識產權查詢',
      infringementMonitor: '侵權風險監測',
      evidenceCollection: '自助取證/固證',
      unitPiece: '件',
      unitPerson: '人',
      unitEnterprise: '家',
      userStats: '用戶統計',
      userTotal: '累計用戶總數',
      userConversion: '用戶服務轉化',
      userConversionOverall: '用戶服務整體轉化率：',
      conversionRate: '轉化率',
      converted: '轉化',
      unconverted: '未轉化',
      userGrowth: '用戶增長趨勢',
      personalUser: '個人用戶',
      enterpriseUser: '企業用戶',
      businessStats: '業務辦理統計',
      businessTotal: '辦理業務總數',
      businessGrowth: '業務辦理增長趨勢',
      originalDigitalFiling: '原創數字備案',
      workTypeDistribution: '作品類型分佈',
      rankingTitle: '用戶業務辦理榜單（TOP 20）',
      rankingAll: '總榜單',
      rankingSerial: '序號',
      rankingUserName: '用戶名稱',
      rankingUserType: '用戶類型',
      rankingTotal: '辦理業務總數',
      rankingBusinessTypes: '辦理業務類型',
      noData: '暫無數據',
      q1: '第一季度',
      q2: '第二季度',
      q3: '第三季度',
      q4: '第四季度',
      monthlyNew: '本月新增辦理',
      monthlyNewDetail: '本月新增辦理 / {n} 件',
      monthlyNewLegend: '本月新增辦理 {n} 件',
      handleProductTotal: '辦理產品發佈存證總數 / {n} 件',
      handleOriginalTotal: '辦理原創作品備案總數 / {n} 件',
      unitGe: '個',
      totalSuffix: '總數',
      statsSuffix: '統計',
      overview: '總覽',
      shareRate: '佔比 {rate}',
      identityCityAssoc: '直屬事業單位及市級文藝家協會',
      identityCityAssocWrapped: '直屬事業單位\n及市級文藝家協會',
      identityDistrictAssoc: '區級文藝家協會',
      identityArtNewOrg: '文藝兩新組織',
      identitySupportRegion: '對口幫扶地區組織',
      serviceChannelStats: '服務渠道統計',
      subChannelTotal: '子渠道總數',
      countSuffix: '數量',
      businessCountSuffix: '業務數量',
      serviceMember: '服務會員',
      serviceMemberTotal: '服務會員總數',
      serviceMemberConversion: '版權數字化治理保護工程服務會員轉化',
      memberOverallRate: '子渠道服務會員整體轉化率：',
      serviceMemberGrowth: '服務渠道平台會員增長趨勢',
      serviceBusinessGrowth: '服務渠道業務增長趨勢',
      artistMemberStats: '服務文藝家會員統計',
      memberTotal: '會員總數',
      personalMember: '個人會員',
      enterpriseMember: '企業會員',
      personalMemberTotal: '個人會員總數',
      enterpriseMemberTotal: '企業會員總數',
      memberUnitLabel: '{name}會員：{n} {unit}',
      primaryBusinessStats: '版權數字化治理保護工程業務辦理統計',
      subChannelOriginalCount: '子渠道原創作品備案業務辦理數量',
      subChannelProductCount: '子渠道產品發佈存證業務辦理數量',
      subChannelBusinessTotal: '子渠道業務辦理總數',
      businessTotalWithName: '{name}業務辦理總數：{n} {unit}',
      originalFilingCount: '{label}：{n} {unit}',
      productDepositCount: '{label}：{n} {unit}'
    },
    subChannel: {
      creditCode: '主體識別碼',
      channelName: '子渠道名稱',
      contact: '聯繫人',
      contactPhone: '聯繫電話',
      district: '所屬區級',
      districtFederation: '所屬區級文聯',
      add: '添加子渠道',
      editTitle: '編輯子渠道',
      name: '子渠道名稱',
      type: '子渠道類型',
      channelType: '渠道類型',
      remark: '備註',
      remarkInfo: '備註信息',
      edit: '編輯',
      placeholderType: '請選擇子渠道類型',
      ruleType: '請選擇子渠道類型',
      missingSubChannelId: '缺少子渠道標識',
      saveSuccess: '保存成功',
      delete: '刪除子渠道',
      deleteConfirm: '確定要刪除子渠道"{name}"嗎？刪除後該企業將恢復為普通企業，子渠道下的用戶將會自動解散。',
      defaultEnterpriseName: '該企業',
      missingIdEdit: '缺少企業標識，無法編輯',
      missingIdDelete: '缺少企業標識，無法刪除',
      deleteSuccess: '刪除成功',
      importStub: '點擊了導入數據',
      dialog: {
        enterpriseQuery: '企業查詢',
        enterpriseQueryDesc: '輸入企業名稱查找已實名認證的普通企業，選定後再填寫下方信息',
        placeholderEntName: '請輸入企業名稱',
        enterpriseName: '企業名稱',
        placeholderSelectEnterprise: '請先查詢匹配企業',
        smsCode: '驗證碼',
        placeholderSmsCode: '請輸入驗證碼',
        getSmsCode: '獲取驗證碼',
        smsCountdown: '{n}秒後重新獲取',
        placeholderSubChannelName: '請輸入子渠道名稱',
        placeholderChannelType: '請選擇渠道類型',
        placeholderDistrict: '請選擇所屬區級文聯',
        placeholderRemark: '請輸入備註信息',
        detailTitle: '查詢到的企業信息',
        creditCode: '統一社會信用代碼',
        confirmSelect: '確認選用',
        selectedOk: '已選用該企業',
        needEntName: '請輸入企業名稱',
        noMatch: '未匹配到企業',
        needSelectEnterprise: '請先選用企業以獲取聯繫電話',
        phoneInvalid: '子渠道聯繫電話格式不正確，無法發送驗證碼',
        smsSent: '驗證碼已發送',
        smsFail: '獲取驗證碼失敗，請重試',
        needQuerySelect: '請先查詢並選用企業',
        needSmsCode: '請填寫聯繫人手機號對應的短信驗證碼',
        addSuccess: '添加成功',
        ruleChannelType: '渠道類型不能為空',
        ruleDistrict: '請選擇所屬區級文聯',
        ruleEnterprise: '企業不能為空',
        ruleSubChannelName: '請輸入子渠道名稱',
        ruleSmsCode: '請輸入驗證碼'
      }
    },
    userMgmt: {
      userTypeAria: '用戶類型',
      personal: '個人用戶',
      enterprise: '企業用戶',
      realName: '真實姓名',
      phone: '手機號碼',
      email: '郵箱',
      idNumber: '證件號碼',
      enterpriseName: '企業名稱',
      creditCode: '主體識別碼',
      contactPhone: '聯繫人電話',
      agentStatus: '代理狀態',
      unauthorized: '未授權',
      authorized: '已授權',
      invitePersonal: '邀請個人用戶',
      inviteEnterprise: '邀請企業用戶',
      nickname: '暱稱',
      contact: '聯繫人',
      contactEmail: '聯繫人郵箱',
      authorizedAgent: '授權代理',
      lastUpdateTime: '最後更新時間',
      inviteAgent: '邀請代理',
      cancelAuth: '取消授權',
      remove: '移除',
      startInvite: '發起邀請',
      loadFail: '加載用戶列表失敗',
      inviteSuccess: '發送邀請成功',
      inviteProxyTitle: '邀請授權代理',
      inviteProxyConfirm: '確定要邀請{type}"{name}"授權代理嗎？',
      inviteProxySent: '邀請授權代理申請已發送',
      cancelAuthTitle: '取消授權代理',
      cancelAuthConfirm: '確定要取消{type}"{name}"的授權代理嗎？',
      removeConfirm: '確定要移除{type}"{name}"嗎？',
      removeSuccess: '移除成功',
      removeFail: '移除失敗',
      fallbackUser: '用戶',
      fallbackEnterprise: '企業',
      unknown: '未知'
    },
    salesman: '業務員管理',
    user: '用戶管理',
    addSalesman: '新增業務員',
    salesmanName: '業務員姓名',
    idCard: '身份證',
    phone: '聯繫電話',
    inviteTime: '邀請時間',
    removeSalesman: '移除業務員',
    confirmRemoveSalesman: '確定要移除業務員"{name}"嗎？',
    removeSuccess: '刪除成功',
    removeFail: '刪除失敗，請重試',
    inviteSuccess: '審批申請已發送，等待對方確認',
    inviteFail: '發送審批申請失敗，請重試',
    serialNumber: '序號',
    loadListFail: '加載業務員列表失敗',
    cannotGetEnterpriseInfo: '無法獲取當前企業信息',
    inviteSalesmanRemark: '邀請{name}成為業務員',
    placeholderSalesmanName: '請輸入業務員姓名',
    placeholderPhone: '請輸入聯繫電話',
    statusChangeSuccess: '狀態修改成功',
    statusChangeFail: '狀態修改失敗，請重試',
    enable: '啟用',
    disable: '禁用',
    confirmStatusChange: '確定要{status}業務員"{name}"嗎？',
    assignCustomer: {
      title: '分配客戶',
      titleWithName: '分配客戶 - {name}',
      currentAssigned: '當前已分配客戶',
      currentAssignedDesc: '查看該業務員名下已分配的客戶，可移除分配',
      goAssign: '去分配用戶',
      goAssignDesc: '選擇客戶並分配給當前業務員',
      clientType: '客戶類型',
      personalClient: '個人客戶',
      enterpriseClient: '企業客戶',
      emptyAssigned: '暫無已分配客戶',
      emptyAssignable: '暫無可分配客戶，請確認已有授權客戶',
      unassign: '移除分配',
      confirmUnassign: '確定取消該客戶與當前業務員的分配關係嗎？',
      unassignSuccess: '已移除分配',
      unassignFail: '移除分配失敗',
      selectAtLeastOne: '請至少選擇一名客戶',
      salesmanIncomplete: '業務員信息不完整',
      cannotAssign: '業務員信息不完整，無法分配客戶',
      assignSuccess: '分配成功',
      assignFail: '分配失敗',
      confirmAssign: '確定分配（已選 {n} 人）',
      loadFail: '加載客戶列表失敗'
    }
  },

  enterpriseAdmin: {
    title: '企業管理員',
    addAdmin: '邀請管理員',
    refresh: '刷新',
    adminName: '管理員姓名',
    adminPhone: '管理員手機號',
    adminStatus: '管理員狀態',
    adminType: '管理員類型',
    removeAdmin: '移除管理員',
    confirmRemoveAdmin: '確定要移除管理員"{name}"嗎？',
    removeSuccess: '移除成功',
    removeFail: '移除失敗，請重試',
    statusChangeSuccess: '狀態修改成功',
    statusChangeFail: '狀態修改失敗，請重試'
  },

  inviteDialog: {
    title: '邀請個人用戶',
    inviteeIdCard: '受邀人身份證',
    inviteePhone: '受邀人手機號碼',
    inviteeInfo: '受邀人詳細信息：',
    refreshQuery: '刷新查詢',
    queryAccount: '受邀人賬號查詢',
    nickname: '暱稱',
    realName: '真實姓名',
    idCard: '身份證',
    phone: '手機號',
    verifiedStatus: '實名認證狀態',
    isAdmin: '是否為管理員',
    isSalesman: '是否為機構業務員',
    verified: '已認證',
    unverified: '未認證',
    verifying: '認證中',
    rejected: '未通過',
    yes: '是',
    no: '否',
    sendSmsCode: '發送驗證碼',
    resendSmsCode: '秒後重發',
    verifyCode: '受邀人手機驗證碼',
    pleaseInputVerifyCode: '請輸入受邀人手機驗證碼',
    confirmInvite: '確認受邀人為業務員',
    confirmInviteAdmin: '確認受邀人為管理員',
    querySuccess: '查詢成功',
    queryFail: '查詢用戶信息失敗，請重試',
    notFound: '未找到匹配的用戶信息',
    pleaseFillForm: '請填寫完整的表單信息',
    pleaseFillIdCardAndPhone: '請先填寫身份證號和手機號',
    pleaseQueryFirst: '請先查詢受邀人信息'
  },

  validation: {
    required: '此項為必填項',
    idCardFormat: '請輸入正確的身份證號碼',
    phoneFormat: '請輸入正確的手機號碼',
    emailFormat: '請輸入正確的郵箱地址',
    minLength: '長度不能少於{min}個字符',
    maxLength: '長度不能超過{max}個字符'
  },

  header: {
    workbench: '工作台',
    freeTrial: '用戶權益',
    ipManagement: '知識產權管理',
    certificateReportVerification: '證書報告驗證',
    navMenu: '導航菜單',
    openNav: '打開導航菜單',
    closeNav: '關閉導航菜單',
    logoAlt: '深圳市版權公共服務平台',
    langSwitchedZh: '語言已切換為簡體中文',
    langSwitchedTw: '語言已切換為繁體中文',
    langSwitchedEn: 'Language switched to English'
  },

  footer: {
    officialAccount: '深圳市版權協會',
    officialAccountSub: '公眾號',
    altOfficialQr: '公眾號二維碼',
    contactUs: '聯繫我們',
    softwareRegistration: '軟件登記:',
    workRegistration: '作品登記:',
    evidenceSolidification: '證據固化:',
    membership: '會員:',
    email: '郵箱:',
    address: '地址:',
    helpCenter: '幫助中心',
    manual: '使用手冊',
    faq: '常見問題',
    aboutUs: '關於我們',
    aboutPlatform: '關於平台',
    officialWebsite: '深圳市版權協會官網',
    copyrightPrefix: '深圳市版權協會 Copyright ©',
    copyrightSuffix: 'All Rights Reserved.',
    icp: '粵ICP備12009572號-7',
    privacy: '隱私協議',
    terms: '用戶註冊協議',
    noGuide: '暫無平台功能指南',
    guideLoadFail: '平台功能指南加載失敗'
  },

  userMenu: {
    altAvatar: '用戶頭像',
    altPersonal: '個人',
    altChannelEnterprise: '渠道企業',
    altOrgEnterprise: '機構企業',
    altNormalEnterprise: '普通企業',
    profile: '個人中心',
    myRights: '我的權益',
    enterpriseAdmin: '企業管理員',
    logout: '退出登錄',
    switchIdentity: '切換身份',
    switchToPersonal: '切換個人用戶',
    switchToEnterprise: '切換企業賬戶',
    confirmSwitchMessage: '確定要切換用戶身份嗎？',
    confirmTip: '提示',
    confirmSwitchOk: '確定切換',
    switching: '正在切換用戶身份...',
    switchSuccess: '切換成功！',
    confirmLogoutMessage: '確定要退出登錄嗎？',
    confirmLogoutOk: '確認退出',
    loggingOut: '正在退出登錄...',
    loggedOut: '已退出登錄',
    logoutFailed: '退出登錄失敗'
  },

  platformGuide: {
    altIcon: '平台功能指南',
    title: '平台功能指南',
    loading: '加載中…',
    empty: '暫無',
    loadFailed: '功能指南加載失敗',
    missingId: '該條目缺少編號，無法打開詳情',
    unnamed: '未命名',
    column: {
      accountManage: '賬戶與管理',
      selfService: '自助功能',
      certVerify: '證書與報告驗證',
      memberCooperate: '會員與合作'
    }
  },

  loginAuth: {
    ariaLabel: '登錄與身份認證提示',
    goLoginPrefix: '請前往',
    goLoginLink: '【登錄】',
    goLoginSuffix: '。',
    goAuthPrefix: '請前往',
    goAuthLink: '【身份認證】',
    goAuthSuffix: '完成實名認證。',
    desc: {
      query: {
        loggedOut: '請先登錄並完成實名認證後方可查詢並查看知識產權數據資產詳情;',
        unverified: '請先完成實名認證後方可查詢並查看知識產權數據資產詳情;'
      },
      filing: {
        loggedOut: '請先登錄並完成實名認證後方可進行數字備案;',
        unverified: '請先完成實名認證後方可進行數字備案;'
      },
      monitoring: {
        loggedOut: '請先登錄並完成實名認證後方可創建版權風險監測任務;',
        unverified: '請先完成實名認證後方可創建版權風險監測任務;'
      },
      ipManagement: {
        loggedOut: '請先登錄並完成實名認證後方可進入知識產權管理;',
        unverified: '請先完成實名認證後方可進入知識產權管理;'
      },
      contractDownload: {
        loggedOut: '請先登錄並完成實名認證後方可下載合同模版;',
        unverified: '請先完成實名認證後方可下載合同模版;'
      },
      reportDownload: {
        loggedOut: '請先登錄並完成實名認證後方可下載報告;',
        unverified: '請先完成實名認證後方可下載報告;'
      },
      attachmentDownload: {
        loggedOut: '請先登錄並完成實名認證後方可下載附件;',
        unverified: '請先完成實名認證後方可下載附件;'
      }
    },
    skipAuth: '暫不認證',
    skipLogin: '暫不登錄',
    goAuth: '去認證',
    goLogin: '去登錄',
    loginBeforeAuth: '請先登錄後再進行身份認證'
  },

  selectIdentity: {
    close: '關閉',
    loading: '加載中...',
    altPersonalAvatar: '個人頭像',
    altEnterpriseAvatar: '企業頭像',
    enterpriseSection: '企業身份',
    enterpriseCount: '當前共{count}個企業身份',
    titleSelectEnterprise: '選擇企業',
    titleSelectUser: '選擇管理用戶',
    confirmLogin: '確認登錄',
    confirmSwitch: '確認切換',
    personalUser: '個人用戶',
    toastSelectEnterprise: '請選擇企業',
    toastSelectUser: '請選擇管理用戶'
  },

  home: {
    nav: {
      forYou: '為你推薦',
      copyrightProtection: '版權保護',
      copyrightService: '版權服務',
      authorizationTrading: '授權交易',
      education: '教育培訓',
      globalCopyrightNews: '全球版權資訊',
      industryEvents: '行業交流&活動',
      regulations: '法規&資助政策',
      industryDistribution: '版權產業分布',
      serviceOrganizations: '版權服務機構'
    },
    secondary: {
      originalWorkFiling: '原創作品備案',
      productLaunchFiling: '產品發布存證',
      copyrightPreExamination: '版權預審',
      intellectualPropertyManagement: '知識產權管理',
      copyrightRiskMonitoring: '版權風險監測',
      evidenceCollection: '自助取證/固證',
      contractTemplates: '合同模版',
      freeConsultation: '免費諮詢',
      workCopyrightRegistration: '作品著作權登記',
      softwareCopyrightRegistration: '軟件著作權登記',
      tsaEvidence: 'TSA證據固化',
      ipDisputeMediation: '知識產權糾紛調解',
      copyrightAppraisal: '版權鑑定比對',
      copyrightCompliance: '版權合規輔導',
      copyrightTraining: '版權培訓合作',
      infringementAppeal: '平台侵權申訴',
      copyrightSocialOrg: '版權社會組織',
      excellentLawFirms: '（優秀）版權專業律所',
      excellentConsulting: '（優秀）版權諮詢服務機構',
      professionalNews: '全球專業資訊',
      licensingNews: '全球授權資訊',
      frontierReport: '全球前沿報告',
      deepAnalysis: '深度解析',
      findIp: '找IP',
      findBrand: '找品牌',
      findSupply: '找供應鏈'
    },
    search: {
      label: '知產查詢',
      placeholder: '限中國大陸依法註冊登記的法人主體',
      workCopyright: '作品著作權',
      softwareCopyright: '軟件著作權',
      trademark: '商標',
      patent: '專利',
      all: '全部',
      button: '查詢',
      verifyFirst: '請先完成實名認證後再進行知產查詢',
      keywordEmpty: '知產查詢關鍵詞不能為空！',
      selectType: '請至少選擇一個知產類型！',
      ownEnterpriseOnly: '只能查詢自己企業的知產',
      enterpriseOnly: '該功能僅限企業賬號使用，請用企業賬號操作。'
    },
    aria: {
      navPrev: '向左切換導航',
      navNext: '向右切換導航',
      secondaryPrev: '向左切換二級菜單',
      secondaryNext: '向右切換二級菜單'
    },
    membership: {
      beta: {
        title: '深圳市級知識產權公共服務網點',
        description: '知產數據查詢、原創作品備案、資產可視化管理等功能現已全面開放，完成實名認證後即可使用平台服務。',
        button: '立即認證'
      },
      title: {
        guest: '登入平台了解更多資訊',
        unverified: '完成身份認證，領取知產管理權益',
        verified: '成為平台大會員，享受專屬權益',
        platform: '升級平台大會員，享受更多權益',
        plus: '升級Plus大會員，享受更多權益',
        international: '國際版大會員，享受最高權益'
      },
      description: {
        guest: '知產服務，讓您的作品創意受到保護和認證。',
        unverified: '知產服務，讓您的作品創意受到保護和認證。',
        verified: '成為會員，享受備案無憂，可讓您的創意作品受到保護和認證。',
        platform: '升級為Plus/國際版大會員，享受更多權益，可讓您的創意作品受到保護和認證。',
        plus: '升級為國際版大會員，享受更多權益，可讓您的創意作品受到保護和認證。',
        international: '國際版大會員，為您護航，讓您的創意作品受到保護和認證。'
      },
      button: {
        guest: '免費試用',
        unverified: '身份認證',
        verified: '成為會員',
        platform: '升級會員',
        plus: '升級會員',
        international: '大會員權益'
      },
      tag: {
        platform: '平台大會員',
        plus: 'Plus大會員',
        international: '國際版大會員'
      },
      iconAlt: '圖示'
    },
    ecosystem: {
      title: '歡迎共建版權價值生態',
      itemAlt: '生態項目'
    },
    message: {
      title: '留言',
      introPrefix: '我們是',
      associationName: '深圳市版權協會',
      introSuffix: ', 歡迎你給我們留言, 提出使用體驗和功能建議。',
      verifyHint: '請先完成身份認證後再留言, 方便我們聯繫你。',
      placeholder: '你可以給我們的平台提一些優化建議, 也可以提出你遇到的版權問題, 我們有非常專業的團隊可以幫助你...',
      submit: '提交',
      toastLoginFirst: '請先登錄後再留言',
      toastEmpty: '請輸入留言內容',
      toastSuccess: '留言提交成功，謝謝您提出寶貴的意見！'
    }
  },

  myRecord: {
    filedWorks: '備案作品',
    transferredWorks: '已轉讓作品',
    authorizedWorks: '已授權作品',
    drafts: '草稿箱',
    filingType: '備案類型',
    selectYear: '選擇年份',
    workName: '作品名稱',
    search: '查詢',
    all: '全部',
    image: '圖片',
    audio: '音頻',
    video: '視頻',
    document: '文檔',
    loading: '加載中...',
    audioWork: '音頻作品',
    documentWork: '文檔作品',
    workFile: '作品文件',
    filingTypeOriginal: '原創數字備案',
    filingTypeProduct: '產品發布存證',
    draftUnavailable: '無法獲取草稿信息',
    detail: {
      section: {
        filingInfo: '備案信息',
        workDetail: '作品詳情',
        workDesc: '作品說明',
        certificate: '證書展示',
        firstPubLink: '首次發表鏈接'
      },
      label: {
        workName: '作品名稱：',
        workType: '作品類型：',
        copyrightOwner: '著作權人：',
        applyTime: '申請時間：',
        filingNo: '備案編號：',
        passTime: '通過時間：',
        filingStatus: '備案狀態：'
      },
      utcSuffix: ' （ UTC+8 ） ',
      status: {
        reviewing: '審核中',
        cancelled: '已取消',
        rejected: '已駁回',
        passed: '已通過',
        revoked: '已撤銷',
        transferred: '已轉讓',
        none: '無'
      },
      btn: {
        goRegistration: '前往作品登記',
        share: '一鍵分享',
        sendEmail: '發送證書郵件',
        openInNewWindow: '在新窗口打開',
        viewInNewWindow: '在新窗口查看',
        downloadPdf: '點擊下載 PDF',
        openInNewWindowClick: '點擊在新窗口查看'
      },
      mainImageTag: '證書顯示主圖',
      mainImage: '主圖',
      mainFile: '主文件',
      zoomImage: '放大圖片',
      audio: '音頻',
      video: '視頻',
      document: '文檔',
      workTitle: '作品《{name}》',
      author: '作者：',
      docPreviewFail: '文檔預覽加載失敗',
      docPreview: '文檔預覽',
      noWorkFile: '暫無作品文件',
      file: '文件',
      certFiling: '作品備案證書',
      certTimestamp: '時間戳',
      certTimestampFull: '時間戳證書',
      certPreviewFail: '證書預覽加載失敗',
      noCertificate: '暫無證書',
      snapshot: '快照截圖',
      noSnapshot: '暫無快照',
      linkDomain: '鏈接域名',
      none: '無',
      vipSubtitle: '平台大會員、大會員Plus、大會員國際版用戶免費使用',
      toast: {
        featureClosed: '暫未開放該功能',
        noFileUrl: '文件地址不存在',
        noImageUrl: '圖片地址不存在',
        certPreview: '證書預覽失敗，請稍後重試',
        noCertFile: '證書文件不存在',
        certDownloadFail: '證書下載失敗，請稍後重試',
        linkCopied: '鏈接已複製到剪貼板',
        copyFail: '複製失敗',
        needRights: '請先獲取權益後再使用此功能',
        emailFail: '郵件發送失敗，請重試',
        emailFailAdmin: '郵件發送失敗，請聯繫管理員！',
        emailSuccess: '郵件發送成功！',
        emailFailRetry: '郵件發送失敗，請稍後重試'
      },
      confirm: {
        sendEmail: '是否確認發送證書郵件',
        title: '操作確認',
        ok: '確認',
        cancel: '取消'
      },
      downloadName: {
        filingCert: '作品備案證書.pdf',
        timestampCert: '時間戳證書.pdf'
      }
    }
  },

  activityDetail: {
    backToList: '返回活動列表',
    activityId: '活動ID: ',
    registerNow: '立即報名',
    ended: '活動已結束',
    contact: '聯繫方式：',
    emptyIntro: '暫無活動介紹',
    notFound: '活動不存在或已下架',
    loading: '加載中...',
    toast: {
      endedCannotRegister: '活動已結束，無法報名',
      contactCopied: '聯繫方式已複製',
      registerSuccess: '報名提交成功'
    },
    register: {
      title: '報名活動',
      submit: '提交',
      placeholder: '請輸入',
      label: {
        name: '姓名',
        sex: '性別',
        position: '職務',
        unitName: '單位名稱',
        phone: '手機號',
        email: '郵箱',
        busStop: '乘車點'
      },
      sex: {
        male: '男',
        female: '女'
      },
      busStop: {
        gaoxinSouth: '高新南',
        shenzhenBay: '深圳灣口岸',
        self: '自行前往'
      },
      rule: {
        name: '請輸入姓名',
        sex: '請選擇性別',
        position: '請輸入職務',
        unitName: '請輸入單位名稱',
        phone: '請輸入手機號',
        phoneInvalid: '請輸入正確的手機號',
        email: '請輸入郵箱',
        emailInvalid: '請輸入正確的郵箱',
        busStop: '請選擇乘車點'
      }
    }
  },


  // 原創作品備案 / 產品發布存證
  digitalFiling: {
    defaultTitle: '原創作品數字備案',
    defaultSubtitle: '版權局《作品登記證書》的快速替代方案，透過時間戳與區塊鏈技術，為原創作品提供快速確權備案。',
    consult: '諮詢/聯繫',
    consultPhone: '諮詢電話：0755-86185583',
    contactPerson: '聯繫人員：鄒小姐',
    wechatQrAlt: '企業微信二維碼',
    wechatQrConfig: '請配置企業微信二維碼',
    wechatQrLabel: '企業微信二維碼',
    steps: {
      upload: '上傳作品',
      completeInfo: '完善作品信息',
      confirmInfo: '確認作品信息',
      pay: '支付費用',
      submit: '提交審核'
    },
    upload: {
      title: '上傳作品',
      formatLabel: '上傳格式：',
      certExample: '證書示例',
      workDisplay: '作品展示',
      mainImageTag: '證書顯示主圖',
      workNamed: '作品《{name}》',
      author: '作者：{name}',
      mainImage: '主圖',
      instructionsOriginal: '支持上傳圖片、word、pdf、音頻、視頻格式作品，單張圖片最大限制10Mb，圖片最多支持上傳6張，單個文件最大限制25Mb。',
      instructionsProduct: '產品發布存證目前僅支持上傳圖片，單張圖片最大限制10Mb，最多支持上傳6張。',
      hintOriginal: '支持上傳圖片、word、pdf、音頻、視頻格式作品',
      hintProduct: '僅支持上傳圖片，單張最大10Mb，最多6張'
    },
    form: {
      basicInfo: '基礎資訊',
      workName: '作品名稱',
      applicant: '申請人',
      workType: '作品類型',
      workTypeLink: '點擊查看著作權作品類型詳細說明與定位',
      originality: '獨創性說明',
      originalityHint: '請簡要說明以下內容 (建議100-200字)',
      firstPubLink: '首次發表鏈接',
      rightsAcquisition: '權利取得方式',
      rightsCommitment: '申請人承諾權利取得方式為真實來源，對所提交的作品未侵犯任何第三方的著作權及其他合法權益。如因作品不實引發任何法律糾紛，由申請人自行承擔全部法律責任。',
      cooperativeWork: '是否合作作品',
      addCoAuthor: '+ 添加合作作者',
      coAuthorName: '合作作者名稱',
      coAuthorType: '合作作者類型',
      coAuthorCard: '身份證號碼/企業信用代碼',
      individualAuthor: '個人合作作者',
      enterpriseAuthor: '企業合作作者',
      placeholder: '請輸入',
      pleaseSelect: '請選擇',
      idCardPlaceholder: '請輸入身份證號碼',
      creditCodePlaceholder: '請輸入統一社會信用代碼',
      action: '操作',
      clear: '清除'
    },
    confirm: {
      workName: '作品名稱：',
      workType: '作品類型：',
      applicant: '申請人：',
      acquisitionMethod: '取得方式：',
      scanSign: '掃碼簽名',
      qrLoading: '二維碼加載中...',
      regenerateSign: '重新生成簽名',
      syncSign: '同步簽名',
      syncTip: '手機簽名成功後點擊此處同步簽名',
      wechatSignTip: '請使用微信掃碼，完善個人簽名；簽名會展示在備案證書，請認真書寫。'
    },
    success: {
      title: '提交成功',
      subtitle: '備案審核已提交，預計1個工作日內出結果。',
      workInfo: '作品信息',
      currentAccount: '當前賬號:',
      businessType: '業務類型:',
      filingStatus: '備案狀態:',
      rightsAcquisition: '權利取得方式:',
      workName: '作品名稱:',
      workType: '作品類型:',
      applicant: '申請人:',
      applyTime: '申請時間:',
      continueFiling: '繼續備案',
      goMyRecord: '前往我的備案',
      statusReviewing: '備案審核中'
    },
    certExample: {
      basic: '基礎版證書',
      international: '國際版證書',
      timestamp: '可信時間戳證書',
      alt: '證書示例'
    },
    btn: {
      next: '下一步',
      nextPage: '下一頁',
      prevPage: '上一頁',
      back: '返回上一步',
      certPreview: '證書預覽'
    },
    intlNamePersonal: '國際用名',
    intlNameEnterprise: '國際名稱',
    typeOriginal: '原創作品備案',
    typeProduct: '產品發布存證',
    rights: {
      '0': { label: '原始取得', tip: '由本人/本單位獨立創作或多個主體聯合創作完成。' },
      '2': { label: '委託創作取得', tip: '委託他人創作依據委託協議約定取得。' },
      '3': { label: '職務作品取得', tip: '依據勞動關係或職務行為依法取得著作權。' },
      '1': { label: '繼受取得', tip: '通過轉讓、繼承、企業合併、資產劃轉等方式取得。' }
    },
    payment: {
      loadingPrice: '正在獲取最新價格...',
      basic: '基礎版',
      basicDesc: '永久雲存儲，司法級哈希值校驗',
      priceUnit: '元/件',
      basicVipFree: '平台大會員、大會員Plus、大會員國際版用戶免費',
      international: '國際版',
      internationalDesc: '含哈希值國際權威時間戳校驗，適配全球主流電商維權',
      internationalVipFree: '大會員國際版用戶免費',
      payable: '應付金額',
      yuan: '元',
      payMethod: '支付方式',
      wechatPay: '微信支付',
      cardPay: '次卡支付',
      cardFreeHint: '會員已享受免費權益，無需使用次卡',
      cardRemain: '(剩餘 {count} 次)',
      noCard: '當前無次卡可抵銷',
      channel: '所屬渠道',
      actualPay: '實付金額',
      memberFree: '會員享受免費權益',
      channelDefault: '渠道',
      channelFree: '{name}-渠道用戶，享受免費權益',
      channelDiscount: '{name}-渠道用戶，享受 {zhe} 折',
      upgradeBasic: '升級平台/Plus大會員，可解鎖<span style="color: #F37C0D">全年不限次數</span>基礎版備案權益',
      upgradeIntl: '升級成為大會員國際版，可解鎖<span style="color: #F37C0D">全年不限次數</span>國際版備案權益',
      openVip: '開通會員',
      goUpgrade: '前往升級',
      confirmSubmit: '確認提交備案',
      payNow: '立即支付'
    },
    workUpload: {
      dragHint: '將文件拖到此處或點擊上傳',
      setMain: '設為主圖',
      delete: '刪除',
      mainBadge: '主圖',
      file: '文件',
      unsupported: '不支持的文件格式',
      imageOnly: '當前僅支持上傳圖片格式',
      conflictNonImage: '已有音頻/視頻/文檔文件，無法再上傳圖片，請先刪除已有文件。',
      maxImages: '最多支持上傳{count}張圖片',
      sizeOver: '{type}大小不能超過 {size}MB',
      typeImage: '圖片',
      typeFile: '文件',
      uploading: '文件上傳中...',
      uploadingDetect: '文件上傳並檢測中...',
      noUrl: '上傳失敗：未獲取到文件地址',
      noQualifiedId: '文件合規檢測失敗：未獲取到作品 ID',
      uploadOk: '上傳成功',
      setMainOk: '已設置為主圖',
      deleted: '圖片已刪除'
    },
    toast: {
      notOpen: '暫未開放',
      needSignature: '請先完成個人簽名',
      needMainImage: '請至少上傳一張圖片並設置主圖',
      needWorkName: '請輸入作品名稱',
      needApplicant: '請輸入申請人',
      needWorkType: '請選擇作品類型',
      needRights: '請選擇權利取得方式',
      needRightsCommit: '請勾選權利取得方式承諾',
      needOriginality: '請輸入獨創性說明',
      needFirstPub: '請輸入首次發表鏈接',
      needReuploadMedia: '音頻、視頻或文檔作品需重新上傳後再提交審核',
      needCoAuthor: '請至少添加一位合作作者',
      coAuthorNameRequired: '第 {index} 位合作作者：請輸入合作作者名稱',
      coAuthorRowError: '第 {index} 位合作作者：{error}',
      coAuthorRemoved: '合作作者已移除',
      idCardInvalid: '識別到的身份證號碼不合規：{error}',
      creditInvalid: '識別到的統一社會信用代碼不合規：{error}',
      noWorkIdForSign: '作品ID缺失，無法生成簽名二維碼，請先保存/創建備案後再簽名',
      qrFail: '生成簽名二維碼失敗，請重試',
      signGot: '簽名已獲取',
      signSynced: '簽名已同步',
      signPending: '暫未獲取到簽名，請完成手機端簽名後再試',
      developing: '功能開發中，敬請期待',
      saveBusy: '操作過於頻繁，請稍後再點擊提交',
      saveFail: '保存失敗，請稍後重試',
      attachOk: '附件上傳成功',
      uploadNoUrl: '上傳失敗，未獲取到文件地址',
      vipLoading: '會員開通組件加載中，請稍後重試',
      selectPayMethod: '請選擇支付方式',
      needIntlName: '請輸入{label}',
      useWechat: '請使用微信支付',
      paySuccess: '支付成功'
    }
  },

  certVerify: {
    bannerAlt: '數字備案信息驗證橫幅',
    tabCertificate: '證書及報告驗證',
    tabTimestamp: '時間戳驗證',
    international: '國際版驗證',
    placeholder: '請輸入證書、報告編號，核驗證書、報告真偽與詳細信息',
    search: '查詢',
    invalidNumber: '證書編號無效：',
    notFound: '未查詢到該證書編號的記錄信息，請核對確認。',
    toastEmpty: '請輸入證書編號',
    toastInvalid: '請輸入正確的證書或報告編號',
    toastEmptyCert: '證書編號不能為空',
    toastNotFilingCert: '該證書編號不是數字備案證書',
    toastNotFoundFiling: '未找到該證書編號對應的備案信息',
    toastQueryFail: '查詢備案信息失敗',
    loading: '查詢核驗中...',
    result: {
      header: {
        platform: '深圳市版權公共服務平台',
        outlet: '深圳市知識產權公共服務網點',
        title: '數字備案信息驗證'
      },
      headerEn: {
        platform: 'Shenzhen Copyright Public Service Platform',
        outlet: 'Shenzhen Intellectual Property Public Service Outlet',
        title: 'Digital Record Verification'
      },
      ipgoAlt: 'IPGO 超級版權助手',
      validAlt: '真實有效',
      revoked: '經核驗已撤銷',
      certNo: '證書編號',
      certNoColon: '證書編號：',
      filingInfo: '備案信息',
      label: {
        filingType: '備案類型：',
        workName: '作品名稱：',
        filingUnit: '備案單位：',
        filingChannel: '備案渠道：',
        workType: '作品類型：',
        applicant: '申請人：',
        filingTime: '備案時間：',
        sha256: 'SHA256：',
        fingerprint: '數字指紋：',
        identity: '認證身份：',
        idType: '證件類型：',
        idNo: '證件號碼：'
      },
      filingType: {
        original: '原創作品備案',
        product: '產品發佈存證'
      },
      filingUnitValue: '深圳市版權協會',
      none: '無',
      utcNote: '（UTC+8 國家授權中心標準時間）',
      utcNoteLegacy: '（中國國家授時中心標準時間）',
      idTypePersonal: '身份證',
      idTypeEnterprise: '營業執照',
      section: {
        workDetail: '作品詳情',
        workDesc: '作品說明',
        firstPubLink: '首次發表鏈接'
      },
      previewTag: '預覽圖',
      mainImage: '主圖',
      mainFile: '主文件',
      zoomImage: '放大圖片',
      downloadPage: '下載當前頁面為圖片',
      downloadImage: '下載圖片',
      audio: '音頻',
      video: '視頻',
      document: '文檔',
      thumbnail: '縮略圖',
      workTitle: '作品《{name}》',
      author: '作者：',
      docPreviewFail: '文檔預覽加載失敗',
      openInNewWindow: '點擊在新窗口查看',
      openInNewWindowBtn: '在新窗口打開',
      docPreview: '文檔預覽',
      openDocInNewWindow: '點擊在新窗口查看文檔',
      docPreviewFailClick: '文檔預覽加載失敗，點擊在新窗口查看',
      noDescription: '暫無說明',
      snapshot: '快照截圖',
      snapshotAlt: '快照',
      noSnapshot: '暫無快照',
      linkDomain: '鏈接域名',
      generatingImage: '正在生成圖片…',
      close: '關閉',
      unnamed: '未命名',
      footer: {
        digital: '數字備案：',
        registration: '作品登記：',
        membership: '會員：',
        address: '地址：',
        software: '軟件登記：',
        evidence: '證據固化：',
        email: '郵箱：',
        qrOfficial: '深圳市版權協會',
        qrOfficialSub: '公眾號',
        qrAlt: '公眾號二維碼'
      },
      toast: {
        noFileUrl: '文件地址不存在',
        noImageUrl: '圖片地址不存在',
        noPageContent: '無法獲取頁面內容',
        imageDownloaded: '圖片已下載',
        generateFail: '生成圖片失敗，請重試',
        generateCertFail: '生成證書信息失敗，請重試',
        noLink: '暫無鏈接',
        copied: '已複製'
      },
      legacy: {
        invalidTitle: '證書編號無效',
        missingInfo: '證書信息不存在',
        verifyFail: '證書核驗失敗，請稍後重試',
        downloadName: '舊版數字備案信息驗證',
        thumbFront: '輔圖',
        thumbSide: '側面圖',
        thumbBack: '背面圖',
        thumbFive: '第五張圖',
        thumbSix: '第六張圖'
      }
    }
  },

  timestampVerify: {
    title: '可信時間戳驗證',
    subtitle: '支持上傳待驗證文件與可信時間戳認證證書，驗證文件的完整性與真實性。',
    fileBlockTitle: '待驗證文件',
    fileUploadHint: '點擊或拖拽要驗證的文件到這裡上傳請確保文件未經處理或重新壓',
    fileUploadHint2: '縮僅支持圖片、word、pdf、音頻、視頻格式單個文件大小',
    fileUploadHint3: '不超過25Mb',
    certBlockTitle: '可信時間戳驗證',
    certUploadHint: '點擊或拖拽《可信時間戳認證證書》到這裡上傳TSA(*.tsa)可信時間戳',
    certUploadHint2: '或可信時間戳認證證書(*.pdf)單個文件大小不超過25Mb',
    verify: '驗證',
    passTitle: '該數據電文（電子文件）已通過驗證',
    passLine1: '證明該數據電文（電子文件）',
    passLine2: '自申請時間戳時起已存在且內容保持完整、未被篡改',
    verifiedFiles: '已驗證文件：',
    fileName: '文件名：',
    certName: '可信時間戳認證證書：',
    certValid: '（證書真實有效）',
    authInfo: '可信時間戳認證信息',
    source: '來源：',
    applicant: '申請人：',
    fileNameLabel: '文件名稱：',
    timeInfo: '時間信息：',
    hashCode: '時間戳認證碼（數字指紋）：',
    fingerprintTip: '轉碼後的數字指紋是聯合信任設計的一種識別文件唯一性的標識值，用於內部標識使用。',
    encodedFingerprint: '轉碼後數字指紋：',
    moreInCert: '更多信息詳見可信時間戳認證證書',
    copyInfo: '複製驗證信息',
    continueVerify: '繼續驗證',
    failTitle: '該數據電文（電子文件）未通過可信時間戳驗證',
    back: '返回',
    copySuccess: '複製成功',
    copyFail: '複製失敗',
    sizeLimit: '上傳文件大小不能超過 25MB!',
    uploadNoUrl: '上傳成功但未返回文件地址',
    defaultFileName: '文件',
    uploadSuccess: '上傳成功',
    uploadFail: '上傳失敗',
    uploadFailRetry: '上傳失敗，請重試',
    needFile: '請上傳待驗證文件',
    needCert: '請上傳可信時間戳認證證書',
    uploading: '文件上傳中，請稍後再驗證',
    verifySubmitted: '驗證請求已提交'
  },

  route: {
    portalHome: '門戶首頁',
    forYou: '為你推薦',
    education: '教育培訓',
    knowledgeClass: '知識課堂',
    practice: '刷題練習',
    practiceDetail: '練習詳情',
    onlineExam: '在線考試',
    examRecordDetail: '考試記錄詳情',
    examRecords: '考試記錄',
    wrongPractice: '錯題練習',
    examDetail: '考試詳情',
    myCertificates: '我的證書',
    courseDetail: '課程詳情',
    courseLearn: '課程學習',
    originalWorkFiling: '原創作品備案',
    productLaunchFiling: '產品發布存證',
    ipQuery: '知識產權查詢',
    ipManagement: '知識產權管理',
    evidenceCollection: '自助取證/固證',
    copyrightSocialOrg: '版權社會組織',
    homePlaceholder: '首頁佔位',
    workCopyrightRegistration: '作品著作權登記',
    softwareCopyrightRegistration: '軟件著作權登記',
    tsaEvidence: 'TSA證據固化',
    ipDisputeMediation: '知識產權糾紛調解',
    copyrightAppraisal: '版權鑑定比對',
    copyrightCompliance: '版權合規輔導',
    copyrightTraining: '版權培訓合作',
    infringementAppeal: '平台侵權申訴',
    findIp: '找IP',
    findBrand: '找品牌',
    findSupply: '找供應鏈',
    ipDetail: 'IP詳情',
    brandDetail: '品牌詳情',
    supplyDetail: '供應鏈詳情',
    derivativeCaseDetail: '衍生作品案例詳情',
    professionalNews: '全球專業資訊',
    professionalNewsDetail: '全球專業資訊詳情',
    licensingNews: '全球授權資訊',
    licensingNewsDetail: '全球授權資訊詳情',
    frontierReport: '全球前沿報告',
    deepAnalysis: '深度解析',
    deepAnalysisDetail: '深度解析詳情',
    industryEvents: '行業交流&活動',
    activityDetail: '活動詳情',
    regulations: '法規&資助政策',
    regulationsDetail: '法規&資助政策詳情',
    industryDistribution: '版權產業分布',
    copyrightPreExamination: '版權預審',
    copyrightRiskMonitoring: '版權風險監測',
    contractTemplates: '合同模版',
    freeConsultation: '免費諮詢',
    timestampVerify: '時間戳驗證',
    excellentLawFirms: '（優秀）版權專業律所',
    excellentConsulting: '（優秀）版權諮詢服務機構',
    maintenance: '系統維護中',
    userCenter: '用戶中心',
    personalAuth: '個人實名認證',
    enterpriseAuth: '企業身份認證',
    enterpriseAdmin: '企業管理員',
    resetPassword: '重置密碼',
    myAuthorization: '我的授權',
    freeRights: '新用戶免費權益',
    platformVip: '平台大會員套餐',
    businessMember: '版權商業會員',
    inviteUser: '邀請用戶領取權益',
    educationRights: '教育培訓權益',
    copyrightPublicAction: '版權公益行動',
    myRecord: '我的記錄',
    myOrder: '我的訂單',
    myInvoice: '我的發票',
    myConsultation: '我的諮詢',
    myActivity: '我的活動',
    myFavorite: '我的收藏',
    messageCenter: '消息中心',
    contentDisplay: '內容展示',
    columnContentDetail: '欄目內容詳情',
    operationGuide: '使用操作指南',
    recommendDetail: '推薦詳情',
    contentDetail: '內容詳情',
    registerAgreement: '深圳市版權公共服務平台用戶註冊協議',
    privacyPolicy: '深圳市版權公共服務平台隱私政策',
    enterpriseWorkbench: '企業工作台',
    eSignature: '電子簽名',
    certificateReportVerification: '證書及報告驗證',
    ipgoInternationalVerification: 'IPGO International Verification',
    ipgoDigitalRecordVerification: 'IPGO Digital Record Verification',
    digitalFilingVerification: '數字備案信息驗證',
    evidenceReportDetail: '存證報告詳情',
    monitoringReportDetail: '版權監測報告詳情'
  }
}
